// Firebase configuration for Brynlore
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyB1ngpevSx1J0QoaMDc6aF1DgyaAf5kchw",
  authDomain: "brynlore.firebaseapp.com",
  projectId: "brynlore",
  storageBucket: "brynlore.firebasestorage.app",
  messagingSenderId: "319579156892",
  appId: "1:319579156892:web:f00c01c6ec2e21ec2b9859",
  measurementId: "G-04DGKV6RLE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Check if running on localhost
const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Enable App Check debug mode on localhost (generates a debug token we can register in Firebase Console)
if (isLocalhost) {
  // @ts-ignore - Setting global variable for Firebase App Check debug mode
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  console.log('🔧 App Check debug mode enabled - check console for debug token');
}

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Connect to emulators in development mode
const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';

if (USE_EMULATORS) {
  console.log('🔧 Connecting to Firebase Emulators...');
  
  // Connect to Auth Emulator
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  console.log('  ✅ Auth Emulator: http://localhost:9099');
  
  // Connect to Firestore Emulator
  connectFirestoreEmulator(db, 'localhost', 8080);
  console.log('  ✅ Firestore Emulator: http://localhost:8080');
  
  // Connect to Functions Emulator
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('  ✅ Functions Emulator: http://localhost:5001');
  
  // Connect to Storage Emulator
  connectStorageEmulator(storage, 'localhost', 9199);
  console.log('  ✅ Storage Emulator: http://localhost:9199');
  
  console.log('  🌐 Emulator UI: http://localhost:4000');
}

// Initialize App Check with reCAPTCHA v3 (uses debug token on localhost, real reCAPTCHA in production)
if (typeof window !== 'undefined') {
  const RECAPTCHA_SITE_KEY = '6Lfcfw8sAAAAAJ2ojDEJY-t3W-c3blnNN0MtszcT';
  
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
    if (isLocalhost) {
      console.log('✅ App Check initialized (localhost debug mode - register the debug token shown above in Firebase Console)');
    } else {
      console.log('✅ App Check initialized (production reCAPTCHA)');
    }
  } catch (error) {
    console.error('❌ App Check initialization failed:', error);
  }
}

export default app;